import React, { useState, useRef } from "react";
import "./Schemes.css";
import BudgetList from "../../components/BudgetAllocation/Schemes/BudgetList";
import { useSelector } from "react-redux";
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from "../../components/Tools/CreateButton";
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';

const Budgets = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const [key, setKey] = useState("list");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchStr, setToSearchStr] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [tier, setTier] = useState("");
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const fyList = financialYears.payload.fy_list;

  const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
  }

  return (
    <>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
      <div className="scheme">
        <div className="row" style={{ padding: "10px 16px" }}>
            <div className="col-md-6">
                <h4 style={{ color: "#28326f", margin:0}}>Budgets</h4>
                <CustomBreadcrumbs linksArray={[]} title="Budgets"/>
            </div>
            <div className="col-md-6"></div>
        </div>
        <BudgetList fromDate={fromDate} toDate={toDate} fyId={fyIdRef.current} searchStr={searchStr} tier={tier} departmentId={departmentId} fy_list={fyList}/>
        {
          (authData.user.user_type === 'l1' && authData.user.department_details.department_level === 'T1') && <CreateButton title={"Add Budget"} url={"/add-budget"}/>
        }
      </div>
    </>
  );
};

export default Budgets;
